var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c(_vm.activeComponent,{tag:"component",attrs:{"src":_vm.fileSrc},on:{"download":_vm.downloadFile,"update:src":function($event){_vm.fileSrc=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }